// JavaScript para manejar el toggle del mega menú en móviles
document.addEventListener('DOMContentLoaded', function() {
  // Botones del segundo nivel (mega-nav__item--toggle)
  const toggleButtons = document.querySelectorAll('.js-submenu-toggle');
  
  toggleButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const megaNavItem = this.closest('.mega-nav__item--toggle');
      
      if (megaNavItem) {
        // Toggle la clase is-active
        megaNavItem.classList.toggle('is-active');
        
        // Cerrar otros submenús abiertos del mismo nivel
        const siblings = megaNavItem.parentElement.querySelectorAll('.mega-nav__item--toggle.is-active');
        siblings.forEach(sibling => {
          if (sibling !== megaNavItem) {
            sibling.classList.remove('is-active');
          }
        });
      }
    });
  });
  
  // Botones del tercer nivel (mega-nav__submenu-item)
  const level3ToggleButtons = document.querySelectorAll('.js-submenu-level3-toggle');
  
  level3ToggleButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const submenuItem = this.closest('.mega-nav__submenu-item');
      
      if (submenuItem) {
        // Toggle la clase is-active
        submenuItem.classList.toggle('is-active');
        
        // Cerrar otros submenús abiertos del mismo nivel
        const siblings = submenuItem.parentElement.querySelectorAll('.mega-nav__submenu-item.is-active');
        siblings.forEach(sibling => {
          if (sibling !== submenuItem) {
            sibling.classList.remove('is-active');
          }
        });
      }
    });
  });
  
  // Botones del cuarto nivel (mega-nav__submenu-item-level-4)
  const level4ToggleButtons = document.querySelectorAll('.js-submenu-level4-toggle');
  console.log('Level 4 toggle buttons found:', level4ToggleButtons.length);
  
  level4ToggleButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      console.log('Level 4 toggle clicked');
      const submenuItemLevel4 = this.closest('.mega-nav__submenu-item-level-4');
      console.log('Found level 4 item:', submenuItemLevel4);
      
      if (submenuItemLevel4) {
        // Toggle la clase is-active
        submenuItemLevel4.classList.toggle('is-active');
        console.log('Toggled is-active, current state:', submenuItemLevel4.classList.contains('is-active'));
        
        // Cerrar otros submenús abiertos del mismo nivel
        const siblings = submenuItemLevel4.parentElement.querySelectorAll('.mega-nav__submenu-item-level-4.is-active');
        siblings.forEach(sibling => {
          if (sibling !== submenuItemLevel4) {
            sibling.classList.remove('is-active');
          }
        });
      }
    });
  });
  
  // Cerrar submenús cuando se hace click fuera
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.mega-nav__item--toggle')) {
      const activeItems = document.querySelectorAll('.mega-nav__item--toggle.is-active, .mega-nav__submenu-item.is-active, .mega-nav__submenu-item-level-4.is-active');
      activeItems.forEach(item => {
        item.classList.remove('is-active');
      });
    }
  });
});
